var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { Api } from "lavva.exalushome";
import { ExalusConnectionService } from "lavva.exalushome/build/js/Services/ExalusConnectionService";
import { DataFrame, Method, Status } from "lavva.exalushome/build/js/DataFrame";
import { Rck21ConfigParams } from "./Rck21ConfigParams";
import { DependencyContainer } from "lavva.exalushome/build/js/DependencyContainer";
import { GetParamsErrorCode } from "../../../ExtaLife";
import { ResponseResult } from "lavva.exalushome/build/js/Services/FieldChangeResult";
import { GetParamsRequest } from "../Common/DataRequest";
export class Rck21ConfigService {
    constructor() {
        this._connection = null;
        this._connection = Api.Get(ExalusConnectionService.ServiceName);
    }
    GetServiceName() {
        return Rck21ConfigService.ServiceName;
    }
    GetAllParamsAsync(device, channel) {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            const result = yield ((_a = this._connection) === null || _a === void 0 ? void 0 : _a.SendAndWaitForResponseAsync(new GetReedSwitchParamsRequest(device.Guid), 35000, false));
            if (result === null || result === undefined)
                return new ResponseResult(GetParamsErrorCode.UnknownError, `Failed to retrieve parameters - unknow error.`);
            switch (result.Status) {
                case Status.OK:
                    if (result.Data != null) {
                        return result.Data;
                    }
                    break;
                case Status.ResourceIsNotAvailable:
                    return new ResponseResult(GetParamsErrorCode.ResourceIsNotAvailable, `Failed to retrieve parameters - cannot communicate with the device.`);
            }
            return new ResponseResult(GetParamsErrorCode.OtherError, `Failed to retrieve parameters, response error: ${result.Status} data: ${result.Data}`);
        });
    }
    SetAllParamsAsync(params, channel) {
        var _a, _b, _c;
        return __awaiter(this, void 0, void 0, function* () {
            const result = yield ((_a = this._connection) === null || _a === void 0 ? void 0 : _a.SendAndWaitForResponseAsync(new SetReedSwitchParamsRequest(params), 35000, false));
            if (result == null || result.Status == null) {
                (_b = DependencyContainer.Log) === null || _b === void 0 ? void 0 : _b.Error(Rck21ConfigService.ServiceName, `Failed to change device parameters - unknow error.`);
                return Status.FatalError;
            }
            if (result.Status !== Status.OK)
                (_c = DependencyContainer.Log) === null || _c === void 0 ? void 0 : _c.Error(Rck21ConfigService.ServiceName, `Failed to change device parameters, response status: ${result.Status}`);
            return result.Status;
        });
    }
    SetReedSwitchOperationModeAsync(device, channel, operationMode) {
        var _a, _b, _c, _d, _e;
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const currentConfig = yield this.GetCurrentConfig(device.Guid);
                let params = new Rck21ConfigParams();
                if (currentConfig === null) {
                    (_a = DependencyContainer.Log) === null || _a === void 0 ? void 0 : _a.Error(Rck21ConfigService.ServiceName, `Failed to change device parameters - cannot read current configuration of device`);
                    return Status.ResourceIsNotAvailable;
                }
                params.DeviceGuid = device.Guid;
                params.LogicNegation = currentConfig.LogicNegation;
                params.SyncTime = currentConfig.SyncTime;
                params.ReedSwitchMode = operationMode;
                const result = yield ((_b = this._connection) === null || _b === void 0 ? void 0 : _b.SendAndWaitForResponseAsync(new SetReedSwitchParamsRequest(params), 35000, false));
                if (result == null || result.Status == null) {
                    (_c = DependencyContainer.Log) === null || _c === void 0 ? void 0 : _c.Error(Rck21ConfigService.ServiceName, `Failed to change device parameters - unknow error.`);
                    return Status.FatalError;
                }
                if (result.Status !== Status.OK)
                    (_d = DependencyContainer.Log) === null || _d === void 0 ? void 0 : _d.Error(Rck21ConfigService.ServiceName, `Failed to change device parameters, response status: ${result.Status}`);
                return result.Status;
            }
            catch (error) {
                (_e = DependencyContainer.Log) === null || _e === void 0 ? void 0 : _e.Error(Rck21ConfigService.ServiceName, `Cannot change device parameters. ${error}`);
                return Status.FatalError;
            }
        });
    }
    SetSynchronizationTimeAsync(device, channel, syncTime) {
        var _a, _b, _c, _d, _e;
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const currentConfig = yield this.GetCurrentConfig(device.Guid);
                let params = new Rck21ConfigParams();
                if (currentConfig === null) {
                    (_a = DependencyContainer.Log) === null || _a === void 0 ? void 0 : _a.Error(Rck21ConfigService.ServiceName, `Failed to change device parameters - cannot read current configuration of device`);
                    return Status.ResourceIsNotAvailable;
                }
                params.DeviceGuid = device.Guid;
                params.LogicNegation = currentConfig.LogicNegation;
                params.SyncTime = syncTime;
                params.ReedSwitchMode = currentConfig.ReedSwitchMode;
                const result = yield ((_b = this._connection) === null || _b === void 0 ? void 0 : _b.SendAndWaitForResponseAsync(new SetReedSwitchParamsRequest(params), 35000, false));
                if (result == null || result.Status == null) {
                    (_c = DependencyContainer.Log) === null || _c === void 0 ? void 0 : _c.Error(Rck21ConfigService.ServiceName, `Failed to change device parameters - unknow error.`);
                    return Status.FatalError;
                }
                if (result.Status !== Status.OK)
                    (_d = DependencyContainer.Log) === null || _d === void 0 ? void 0 : _d.Error(Rck21ConfigService.ServiceName, `Failed to change device parameters, response status: ${result.Status}`);
                return result.Status;
            }
            catch (error) {
                (_e = DependencyContainer.Log) === null || _e === void 0 ? void 0 : _e.Error(Rck21ConfigService.ServiceName, `Cannot change device parameters. ${error}`);
                return Status.FatalError;
            }
        });
    }
    SetLogicNegationAsync(device, channel, logicNegation) {
        var _a, _b, _c, _d, _e;
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const currentConfig = yield this.GetCurrentConfig(device.Guid);
                let params = new Rck21ConfigParams();
                if (currentConfig === null) {
                    (_a = DependencyContainer.Log) === null || _a === void 0 ? void 0 : _a.Error(Rck21ConfigService.ServiceName, `Failed to change device parameters - cannot read current configuration of device`);
                    return Status.ResourceIsNotAvailable;
                }
                params.DeviceGuid = device.Guid;
                params.LogicNegation = logicNegation;
                params.SyncTime = currentConfig.SyncTime;
                params.ReedSwitchMode = currentConfig.ReedSwitchMode;
                const result = yield ((_b = this._connection) === null || _b === void 0 ? void 0 : _b.SendAndWaitForResponseAsync(new SetReedSwitchParamsRequest(params), 35000, false));
                if (result == null || result.Status == null) {
                    (_c = DependencyContainer.Log) === null || _c === void 0 ? void 0 : _c.Error(Rck21ConfigService.ServiceName, `Failed to change device parameters - unknow error.`);
                    return Status.FatalError;
                }
                if (result.Status !== Status.OK)
                    (_d = DependencyContainer.Log) === null || _d === void 0 ? void 0 : _d.Error(Rck21ConfigService.ServiceName, `Failed to change device parameters, response status: ${result.Status}`);
                return result.Status;
            }
            catch (error) {
                (_e = DependencyContainer.Log) === null || _e === void 0 ? void 0 : _e.Error(Rck21ConfigService.ServiceName, `Cannot change device parameters. ${error}`);
                return Status.FatalError;
            }
        });
    }
    GetCurrentConfig(deviceGuid) {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            const result = yield ((_a = this._connection) === null || _a === void 0 ? void 0 : _a.SendAndWaitForResponseAsync(new GetReedSwitchParamsRequest(deviceGuid), 35000, false));
            if (result === null || result === undefined)
                return null;
            switch (result.Status) {
                case Status.OK:
                    if (result.Data != null) {
                        return result.Data;
                    }
                    break;
                case Status.ResourceIsNotAvailable:
                    return null;
            }
            throw new Error(`Failed to read current configuration of device! No data in response.`);
        });
    }
}
Rck21ConfigService.ServiceName = "Rck21ConfigService";
class GetReedSwitchParamsRequest extends DataFrame {
    constructor(guid) {
        super();
        this.Resource = "/extalife/device/parameters/reedswitch";
        this.Method = Method.Get;
        this.Data = new GetParamsRequest(guid);
    }
}
class SetReedSwitchParamsRequest extends DataFrame {
    constructor(data) {
        super();
        this.Resource = "/extalife/device/parameters/reedswitch";
        this.Method = Method.Put;
        this.Data = data;
    }
}
//# sourceMappingURL=Rck21ConfigService.js.map